export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.first_name'
  }),
  intl.formatMessage({
    id: 'table.last_name'
  }),
  intl.formatMessage({
    id: 'table.email'
  }),
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.nao'
  })
]

export const line = (data = []) =>
  data.map(item => ({
    line: [
      item.globalId || item.id,
      item.person.firstName,
      item.person.lastName,
      item.person.email,
      item.organization.name,
      item.organization.parentNAO ? item.organization.parentNAO.name : ''
    ]
  }))
